// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 424 ? "d50e61c5" : chunkId) + "." + {"424":"d15296a7c1846940","670":"b353269acf77a247"}[chunkId] + ".js";
};